import { React, useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useNavigate } from "react-router-dom";
import { Divider } from "material-ui";

//
import MakePayment from "./customRoutes/MakePayment";
import PaymentReceived from "./customRoutes/PaymentReceived";
import ChangeDueDate from "./customRoutes/ChangeDueDate";
import DueDateChanged from "./customRoutes/DueDateChanged";
import CheckLoanBalance from "./customRoutes/CheckLoanBalance";
import DocumentStatus from "./customRoutes/DocumentStatus";
import NewCustomerLanding from "./customRoutes/NewCustomerLanding";
import NewCustomerLandingSpanish from "./customRoutes/NewCustomerLandingSpanish";
//
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import { useTheme } from "@mui/material/styles";
import { PauseOutlined } from "@mui/icons-material";
import TextField from "material-ui/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

export default function Landing() {
    const theme = useTheme();

    const [verified, setVerified] = useState(null);
    const [categories, setCategories] = useState(null);
    const [categoriesLoading, setCategoriesLoading] = useState(true);
    const [breadcrumbs, setBreadcrumbs] = useState(null);
    const [IVRSettings, setIVRSettings] = useState(null);
    const [startDate, setStartDate] = useState(new Date());
    const navigate = useNavigate();
    const [customRoute, setCustomRoute] = useState(null);
    const [customVar, setCustomVar] = useState("");
    const [audioPlaying, setAudioPlaying] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [dateRange, setDateRange] = useState([]);
    const [newDueDate, setNewDueDate] = useState("");

    const last_4_ssn = useRef(null);
    const zip_code = useRef(null);
    const customerForm = useRef(null);
    let queryParams = new URLSearchParams(window.location.search);
    let categorySlug = queryParams.get("c") ?? "root";
    let clientUUID = queryParams.get("cid") ?? "root";
    let changeDueDate;
    let d = "";

    const updateDueDate = () => {
        if (newDueDate === "") {
            alert("Date is required");
        } else {
            // process change
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");

            var raw = JSON.stringify({
                loan_number: customerFields.loan_number,
                days_to_extend: newDueDate,
            });

            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                body: raw,
                redirect: "follow",
            };

            fetch("https://api.agentassist.com:4002/api/assist_ivr/change_due_date", requestOptions)
                .then((response) => response.json())
                .then((result) => {
                    let validCustomer = result.isCustomerFound;
                    if (validCustomer) {
                        updateCustomerField("loan_number", result.selectedLoanKey);
                        getLoanInfo(result.selectedLoanKey);
                    } else {
                        loginButton.current.disabled = false;

                        setErrorMessage("Unfortunately, we cannot locate an account with that information.");
                    }
                })
                .catch((error) => console.log("error", error));
            setCustomVar("dueDateChanged");
        }
    };

    const handleChange = () => {};

    let loginButton = useRef();

    let dueDateChanged, paymentReceived;

    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric" };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const [customerFields, setCustomerFields] = useState({
        zip_code: "",
        last_4_ssn: "",
        dob_year: "",
        dob_month: "",
        dob_day: "",
        loan_balance: "0",
    });

    const updateCustomerField = (n, v) => {
        console.log("set " + n + " to " + v);
        setCustomerFields((prevState) => ({
            ...prevState,
            [n]: v,
        }));
    };

    const gotoScreen = (screenName, customVal = "") => {
        if (screenName === "dueDateChanged") {
            dueDateChanged = new DueDateChanged(gotoScreen, customerFields, customVal);
            setCustomRoute(eval(screenName));
        } else {
            if ((screenName = "paymentReceived")) {
                paymentReceived = new PaymentReceived(gotoScreen, customerFields, customVal);
                setCustomRoute(eval(screenName));
            } else {
                setCustomRoute(eval(screenName));
            }
        }
    };
    const checkLoanBalance = new CheckLoanBalance(gotoScreen, customerFields);
    const documentStatus = new DocumentStatus(gotoScreen, customerFields);
    const makePayment = new MakePayment(gotoScreen, customerFields);

    const newCustomerLanding = new NewCustomerLanding(gotoScreen, customerFields);
    const newCustomerLandingSpanish = new NewCustomerLandingSpanish(gotoScreen, customerFields);

    let introAudio;

    let isTop = false;

    if (categorySlug === "root") {
        isTop = true;
    }

    async function getData() {
        const response = await fetch(process.env.REACT_APP_VIRTUAL_AGENT_API_SERVER_URL + "/api/assist_ivr/subordinates/" + clientUUID + "/" + categorySlug);
        const data = await response.json();
        setCategories(data);
        setCategoriesLoading(false);
        console.log(data);
    }

    async function getSettings() {
        const response = await fetch(process.env.REACT_APP_VIRTUAL_AGENT_API_SERVER_URL + "/api/assist_ivr_settings/" + clientUUID);
        const data = await response.json();
        setIVRSettings(data);
        console.log(data);
    }

    async function getLoanInfo(loan_number) {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            loan_number: loan_number,
        });

        console.log(raw);

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch("https://api.agentassist.com:4002/api/assist_ivr/lookup_loan", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                let validCustomer = result.isLoanInformationFound;
                if (validCustomer) {
                    let currentDueDate = new Date(result.dueDate);
                    updateCustomerField("loan_balance", result.balanceDec);
                    updateCustomerField("loan_amount_due", result.dueAmountDec);
                    updateCustomerField("loan_due_date", currentDueDate);
                    updateCustomerField("max_date_change_days", result.maxDueDateAdjustmentDays);
                    updateCustomerField("can_change_due_date", result.canChangeDueDate);

                    setVerified(true);
                    setErrorMessage("");
                    console.log("SUBMIT");
                    categorySlug = categorySlug;
                    clientUUID = clientUUID;
                    setCategoriesLoading(true);
                    getData();
                    getBreadcrumb();
                    window.scrollTo(0, 0);
                    // load loan-specific components
                    let dates = [];
                    let maxDay = result.maxDueDateAdjustmentDays + 1;
                    console.log(result);
                    for (let i = 1; i < maxDay; i++) {
                        var date = new Date(result.dueDate);
                        date = date.setDate(date.getDate() + i);
                        let day = new Date(date);
                        let lbl = day.toLocaleDateString();
                        dates.push({
                            date: day.toLocaleDateString(),
                            label: lbl,
                        });
                    }
                    setDateRange(dates);
                    console.log("added change due date screen");
                } else {
                    loginButton.current.disabled = false;
                    setErrorMessage("Loan Not Found");
                }
            })
            .catch((error) => console.log("error", error));
    }
    const handleChangeDueDate = (e) => {
        setNewDueDate(e.target.value);
    };

    async function findCustomer() {
        loginButton.current.disabled = true;

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            last_4_ssn: customerFields.last_4_ssn,
            dob_year: customerFields.dob_year,
            dob_month: customerFields.dob_month,
            dob_day: customerFields.dob_day,
            zip_code: customerFields.zip_code,
        });

        console.log(raw);

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch("https://api.agentassist.com:4002/api/assist_ivr/lookup_customer", requestOptions)
            .then((response) => response.json())
            .then((result) => {
                let validCustomer = result.isCustomerFound;
                if (validCustomer) {
                    updateCustomerField("loan_number", result.selectedLoanKey);
                    getLoanInfo(result.selectedLoanKey);
                } else {
                    loginButton.current.disabled = false;

                    setErrorMessage("Unfortunately, we cannot locate an account with that information.");
                }
            })
            .catch((error) => console.log("error", error));
    }

    async function getBreadcrumb() {
        const response = await fetch(process.env.REACT_APP_VIRTUAL_AGENT_API_SERVER_URL + "/api/assist_ivr/path/" + clientUUID + "/" + categorySlug);
        const data = await response.json();
        setBreadcrumbs(data);
        console.log(data);
    }

    const processForm = (e) => {
        setErrorMessage("Confirming Details...");
        findCustomer();

        //        saveVerification();
    };

    const showAuth = () => {
        console.log("CCCCC");
        setVerified(false);
        setBreadcrumbs([]);
        setCategories([]);
        isTop = true;
    };

    const linkClicked = (s, u, a, custom = "") => {
        if (a === 1) {
            console.log("AUTH REQUIRED");
            // requires auth
            showAuth();
        } else {
            if (custom !== "") {
                if (custom !== "changeDueDate") {
                    if (custom === "makePayment") {
                        if (customerFields.can_make_payment) {
                            console.log("show " + custom);
                            setCustomRoute(eval(custom));
                            setCustomVar("");
                        } else {
                            alert("We are unable to schedule a payment at this time. Thank you");
                            return false;
                        }
                    } else {
                        console.log("show " + custom);
                        setCustomRoute(eval(custom));
                        setCustomVar("");
                    }
                } else {
                    if (customerFields.can_change_due_date) {
                        setCustomRoute(null);
                        setCustomVar("changeDueDate");
                    } else {
                        alert("We are unable to change your due date at this time. Thank you");
                        return false;
                    }
                }
            } else {
                setCustomRoute(null);
            }
            categorySlug = s;
            clientUUID = u;
            console.log(s);
            setCategoriesLoading(true);
            getData();
            getBreadcrumb();
        }
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        console.log("GO");
        setCategoriesLoading(true);
        getData();
        getBreadcrumb();
        getSettings();
    }, []);

    const audioRef = useRef();

    const playIntroAudio = () => {
        setAudioPlaying(true);
        audioRef.current.play();
    };

    const pauseIntroAudio = () => {
        setAudioPlaying(false);
        audioRef.current.pause();
    };

    return (
        <>
            <Grid className="virtualAgentContainer" container spacing={0}>
                <Grid item xs={12}>
                    {breadcrumbs ? (
                        <>
                            <Grid container spacing={2} sx={{ marginLeft: "0px", marginBottom: "10px", paddingTop: "10px", backgroundColor: "#FFF", position: "fixed", borderBottom: "1px solid #CCC" }}>
                                {!isTop ? (
                                    <Link to={"/landing?cid=" + clientUUID} onClick={() => linkClicked("root", clientUUID)}>
                                        <Button className="homeIconContainer">
                                            <HomeIcon />
                                        </Button>
                                    </Link>
                                ) : (
                                    <Button className="homeIconContainer" disabled>
                                        <HomeIcon />
                                    </Button>
                                )}
                                {breadcrumbs.map((breadcrumb) => (
                                    <>
                                        {breadcrumb.custom_route ? (
                                            <Link to={"/landing?c=" + breadcrumb.slug + "&cid=" + clientUUID + "&route=" + breadcrumb.custom_route} onClick={() => linkClicked(breadcrumb.slug, clientUUID, breadcrumb.auth_checkpoint, breadcrumb.custom_route)} className="breadcrumb">
                                                <Button key={breadcrumb.slug}>{breadcrumb.label}</Button>
                                            </Link>
                                        ) : (
                                            <Link to={"/landing?c=" + breadcrumb.slug + "&cid=" + clientUUID} onClick={() => linkClicked(breadcrumb.slug, clientUUID, breadcrumb.auth_checkpoint)} className="breadcrumb">
                                                <Button key={breadcrumb.slug}>{breadcrumb.label}</Button>
                                            </Link>
                                        )}
                                    </>
                                ))}
                            </Grid>
                        </>
                    ) : (
                        <></>
                    )}
                    {IVRSettings && (
                        <>
                            <div className="headerRow" style={{ marginTop: "50px", marginBottom: "30px" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 281 119" fill="none" preserveAspectRatio="xMidYMid meet" class="css-1r6vdia" style={{ width: "100px" }}>
                                    <title>Speedy Cash.</title>
                                    <path d="M43.28 66.89c1.36-5.57 4.53-11.1 9.19-16.44-30.47 1.83-32.92 2.46-32.94 2.39 27.77-7.48 39.54-10.08 39.63-10.43C28.85 44.99 0 48.61 0 48.61c25.88-6.85 60.86-14.97 60.5-14.93-29.35 3.2-52.34 5.25-51.97 5.22C108.28 14.17 143.38 7.76 155.73 6.3c3.93-.53 7.9-.96 11.9-1.3 61.61-5.24 105.82 13.98 98.74 42.93-7.07 28.95-62.75 56.66-124.36 61.9-61.6 5.24-105.8-13.98-98.73-42.93z" fill="#ED1B29"></path>
                                    <path d="M40.54 82.59l.1-.35-9.87-2.03 17.17-6c.82-.32 8.67-3.23 14.56-3.73 10.7-.92 18.24 3.03 16.83 8.8C77.92 85.08 68.1 90.5 57.38 91.4c-10.71.91-18.25-3.04-16.84-8.81z" fill="#fff"></path>
                                    <path d="M166.52 1.97l1.9-.17c65.36-5.56 112.25 14.83 104.74 45.54-7.5 30.71-66.57 60.11-131.93 65.67l-1.89.16c64.6-5.96 122.6-35.09 130.04-65.5 7.43-30.42-38.5-50.71-102.86-45.7z" fill="#00502F"></path>
                                    <path d="M161 10.62c1.8-.2 3.59-.36 5.39-.52 55.6-4.73 95.5 12.62 89.1 38.75-6.38 26.12-56.63 51.13-112.22 55.86-1.8.15-3.59.28-5.35.39 53.42-5.83 100.67-30.06 106.85-55.34 6.18-25.28-30.98-42.34-83.76-39.14z" fill="#005D45"></path>
                                    <path d="M61.94 68.18l1.14-.11c13.18-1.12 22.45 3.73 20.7 10.84-1.73 7.1-13.81 13.78-26.99 14.9l-1.13.08C68.38 92.49 79.83 86 81.52 79.1c1.68-6.9-7.01-11.67-19.58-10.92z" fill="#fff"></path>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M74.37 81.05c-.78.37-2.65 1.27-5 1.47-2.92.25-4.54-.9-4.11-2.66.26-1.07 1.62-3.1 5.29-3.42 2.3-.2 3.73.4 4.6.81l.9-3.74c-.88-.2-2.56-.6-5.64-.33-7.76.66-10.95 4.9-11.54 7.33-.78 3.18 1.78 6.06 8.28 5.5 2.92-.24 4.6-.87 6.38-1.55l.84-3.41z" fill="#005D45"></path>
                                    <path d="M47.56 82.18l-4.99-.48 3.08-1.22c-1.26 0-6.71.3-7.53.46 2.4-.81 7.4-2.4 7.85-2.54l-11.83 1.44c5.94-1.75 15.54-4.47 16.45-4.73.8-.22 1.6-.36 2.42-.43 2.41-.2 4.19.35 5.16 1l-.85 3.46c-.83-.57-2.3-1.41-3.9-1.28-1.07.1-1.65.6-1.73.96-.16.63.81.95 2.34 1.48 1.23.43 3.5 1.22 3 3.26-.15.64-1.48 3.9-8.04 4.46-3.35.28-4.78-.18-5.46-.4l.85-3.47c1.14.5 2.47.83 4.02.7 1.66-.15 2.1-.71 2.16-.98.13-.54-.57-.79-2.71-1.58l-.3-.11z" fill="#005D45"></path>
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M127.8 68.62l-.55-.1c-.33.28-.68.46-1 .49-.56.05-1.5-.28-3.41-.67-1.97-.4-4.9-.65-9.34-.27-8.86.75-20.27 6.28-24.22 15.67-3.96 9.4 3.47 13.32 12.33 12.57 8.26-.7 14.6-3.97 15.7-4.07.4-.03.6 0 .6.36l.83-.43-2.24-7.75-.77.41c0 .26.14.45 0 .76-.63 1.53-8.6 3.57-10.54 3.73-4.48.39-9.53-.96-7.27-6.31 2.25-5.36 8.84-7.69 13.33-8.07 4.7-.4 8.4.6 7.95 1.65-.15.37-.3.58-.44.8l.4.32 8.63-9.09zM148.65 86.24c-.06.66-.01 4.35-.1 4.56-.14.32-.53.6-1.32.72l-.27.63 10.91-.93.27-.63c-.67.06-.86-.23-.89-1.44-.07-7.69-.28-22.8-.1-23.22.22-.53.65-.67 1.28-.77l.27-.63-14.46 1.23-.26.63c.47 0 1.04.06.88.43-.13.31-19.22 24.2-20.22 25.46-.69.86-1.1 1.1-1.95 1.33l-.26.63 9.8-.84.27-.63c-.78.07-.91-.12-.78-.44.13-.31.75-1.02 3.8-4.98l13.13-1.11zm.21-16.12l.12 12.04-10.3.88 10.18-12.92zM183.6 78.86c1.63.22 5.3-.14 4.22 2.42-1.04 2.47-4.68 3.14-6.62 3.3l2.4-5.72zm-1.06-6.34c-1.73.05-4.5-.12-3.54-2.38.97-2.31 3.97-2.97 5.88-3.18l-2.34 5.56zm-18.9 16.75c.36-.24 1-.75 1.39-.78.5-.04 3.98 2.1 10.13 1.57l-2.32 5.5 3.88-.32 2.31-5.51c5.78-.55 13.4-3.42 16.19-10.03 2.65-6.3-4.2-6.88-8.98-7.09l2.51-5.98c4.45-.28 7 1.53 6.71 2.21-.16.37-.45.7-.56.96l.52.16 6.43-7.78-.6-.1c-.31.22-.75.62-1.13.65-.5.04-4.82-1.36-9.2-1.24l1.88-4.47-3.88.33-1.88 4.47c-6.03.86-12.5 3.44-15.26 10-2.34 5.56 3.84 6.6 8.2 6.8l-2.61 6.19c-4.94-.34-7.58-1.28-7.63-2.44-.02-.46.19-.83.44-1.3l-.55-.2-6.57 8.24.57.16zM241.82 58.98c.2-.47.52-.86 1.95-1.08l.27-.63-11.41.97-.27.64c1.34-.02 1.35.33 1.15.8l-3.5 8.35-14.41 1.23 3.52-8.35c.19-.47.51-.85 1.94-1.07l.27-.64-11.41.97-.27.64c1.34-.02 1.35.34 1.16.8l-10.3 24.47c-.2.47-.52.85-1.95 1.08l-.26.63 11.4-.97.27-.63c-1.34.01-1.35-.34-1.15-.82l4.08-9.7 14.4-1.23-4.08 9.7c-.2.48-.52.86-1.95 1.09l-.27.63 11.41-.97.27-.63c-1.34 0-1.35-.34-1.16-.82l10.3-24.46zM126.35 42.91l6.48-14.86 2.92-.25c1.76-.15 2.13.2 1.53 1.6l-4.38 10.02c-1 2.3-2.12 3.12-3.58 3.24l-2.97.25zm-18.52 20.21l10.07-.86 5.18-11.86 3.4-.3c9.04-.76 13.34-3.51 17.69-13.47l3.17-7.26c3.31-7.6.48-9.8-6.8-9.19l-14.5 1.24-18.21 41.7zM137.4 60.6l20.08-1.7 3.27-7.49-10.01.85 4.55-10.43 8.61-.73 3.12-7.14-8.62.73 4-9.15 9.29-.8 3.27-7.48-19.36 1.64-18.2 41.7zM162.45 58.47l20.1-1.7 3.26-7.49-10.01.85 4.55-10.43 8.62-.73 3.11-7.14-8.62.73 4-9.16 9.3-.78 3.26-7.5-19.36 1.65-18.2 41.7zM187.51 56.34l13.11-1.11c9.4-.8 13.21-2.95 19.2-16.66l4.55-10.43c5.98-13.7 3.87-15.4-5.54-14.61l-13.11 1.11-18.2 41.7zm25.17-35.41l2.66-.23c2.19-.18 2.27.7.91 3.8l-8.29 19.01c-1.36 3.12-2.25 4.08-4.43 4.26l-2.67.23 11.81-27.07zM224.16 53.23l9.7-.83 5.9-13.48L261.3 9.98l-9.95.85-12.27 19.06h-.12l4.13-18.36-9.95.84-3.1 27.38-5.88 13.48z"
                                        fill="#005D45"
                                    ></path>
                                    <path
                                        d="M92.74 51.2l-1.3 3c-1.26 2.88-1.77 4.03 1.2 3.78 2.25-.2 3.28-.95 4.06-2.73l1.96-4.5c1.26-2.88.67-2.99-4.08-3.75-7.05-1.12-7.8-2.78-4.55-10.21-6.99-1.46-21.7-4.5-22.68-4.44 22.17-6.73 33.13-8.78 35.78-9.22 1.58-.3 3.36-.5 5.43-.67 8.74-.74 10.64 1.31 8.1 7.13l-2.18 5.01-8.98.77.88-2.02c1.6-3.69 1.43-3.95-1.12-3.73-2.67.22-3.3 1.28-4.16 3.24l-1.2 2.76c-1.17 2.65-.64 3.05 2.03 3.49 9.6 1.73 10.48 2.38 5.8 13.1-4.38 10.01-9.04 12.13-17.6 12.86-10.92.93-11.87-1.32-8.25-9.62L83.4 52l9.35-.8z"
                                        fill="#005D45"
                                    ></path>
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M131.58 68.3l-.54-.1c-.33.28-.67.46-1 .49-.56.05-1.5-.28-3.41-.67-1.97-.4-4.9-.65-9.34-.27-8.86.75-20.27 6.28-24.22 15.67-3.96 9.4 3.47 13.32 12.33 12.57 8.26-.7 14.6-3.97 15.7-4.07.4-.03.6 0 .6.36l.83-.43-2.24-7.76-.77.42c0 .26.14.45 0 .76-.63 1.52-8.6 3.57-10.54 3.73-4.48.39-9.52-.96-7.27-6.31 2.25-5.36 8.84-7.69 13.33-8.07 4.7-.4 8.4.6 7.95 1.65-.15.37-.3.58-.44.8l.4.32 8.63-9.09zM152.44 85.92c-.06.66-.02 4.35-.1 4.56-.14.32-.52.6-1.32.72l-.27.63 10.91-.93.27-.63c-.67.06-.87-.23-.89-1.44-.07-7.69-.28-22.8-.1-23.23.22-.52.65-.66 1.28-.76l.27-.63-14.46 1.23-.27.63c.48 0 1.05.06.89.43-.13.31-19.22 24.2-20.22 25.45-.69.87-1.1 1.11-1.95 1.34l-.26.63 9.8-.84.26-.63c-.77.07-.9-.12-.77-.44.13-.31.75-1.02 3.8-4.98l13.13-1.11zm.21-16.12l.12 12.04-10.3.87 10.18-12.9zM187.4 78.54c1.61.22 5.3-.15 4.2 2.43-1.03 2.46-4.67 3.13-6.61 3.3l2.4-5.73zm-1.08-6.34c-1.72.05-4.48-.12-3.53-2.38.97-2.31 3.97-2.97 5.88-3.18l-2.35 5.56zm-18.9 16.74c.37-.23 1.01-.74 1.4-.77.5-.05 3.98 2.09 10.12 1.57l-2.31 5.5 3.87-.32 2.32-5.52c5.79-.54 13.4-3.41 16.19-10.03 2.65-6.3-4.2-6.88-8.98-7.08l2.51-5.98c4.45-.28 7 1.53 6.71 2.21-.15.37-.45.7-.56.96l.52.16 6.43-7.78-.6-.1c-.32.22-.74.61-1.13.65-.5.04-4.82-1.36-9.2-1.24l1.88-4.47-3.88.33-1.88 4.46c-6.02.87-12.5 3.45-15.26 10.01-2.34 5.56 3.84 6.6 8.19 6.8l-2.6 6.19c-4.94-.34-7.58-1.28-7.63-2.44-.02-.46.19-.83.44-1.3l-.55-.21-6.57 8.25.57.15zM245.61 58.66c.2-.47.52-.85 1.95-1.08l.26-.63-11.4.97-.27.63c1.34-.01 1.35.34 1.16.82l-3.52 8.34-14.4 1.22 3.52-8.34c.2-.47.51-.86 1.94-1.08l.27-.63-11.41.97-.27.63c1.34-.01 1.35.34 1.15.81l-10.3 24.47c-.19.47-.51.85-1.94 1.08l-.27.62 11.42-.97.26-.63c-1.34.02-1.35-.34-1.15-.8l4.08-9.72 14.4-1.22-4.08 9.7c-.2.48-.52.86-1.95 1.08l-.26.63 11.4-.97.27-.63c-1.34.01-1.35-.34-1.16-.8l10.3-24.47zM130.21 42.58l6.49-14.86 2.91-.25c1.76-.15 2.13.21 1.53 1.6l-4.38 10.01c-1 2.3-2.12 3.12-3.57 3.25l-2.98.25zM111.7 62.8l10.08-.86 5.17-11.86 3.4-.3c9.04-.76 13.34-3.5 17.7-13.47l3.16-7.26c3.32-7.6.48-9.8-6.8-9.18l-14.5 1.23-18.2 41.7zM141.26 60.28l20.09-1.71 3.26-7.49-10.01.85 4.55-10.42 8.62-.74 3.11-7.14-8.61.73 4-9.15 9.28-.8 3.27-7.48-19.36 1.65-18.2 41.7zM166.32 58.15l20.09-1.71 3.26-7.49-10.01.85 4.55-10.42 8.62-.73 3.11-7.15-8.61.73 4-9.15 9.28-.8 3.27-7.48-19.36 1.64-18.2 41.7zM191.38 56.01l13.1-1.1c9.41-.8 13.22-2.96 19.2-16.67l4.56-10.42c5.97-13.71 3.86-15.42-5.55-14.62l-13.1 1.12-18.21 41.7zm25.16-35.41l2.67-.23c2.18-.18 2.27.7.91 3.8l-8.3 19.02c-1.35 3.1-2.24 4.07-4.43 4.25l-2.67.23 11.82-27.07zM228.03 52.9l9.7-.83 5.89-13.47 21.55-29.01-9.96.85-12.26 19.12h-.12l4.13-18.42-9.95.84-3.1 27.44-5.88 13.48z"
                                        fill="#fff"
                                    ></path>
                                    <path
                                        d="M96.6 50.87l-1.3 3c-1.26 2.88-1.76 4.03 1.21 3.78 2.24-.2 3.28-.95 4.05-2.73l1.97-4.5c1.26-2.87.66-2.99-4.09-3.75-7.05-1.12-7.79-2.78-4.54-10.2l.2-.46-6.61-1.04 8.12-2.38c-1.12.03-15.7.6-15.8.65 6.3-1.41 17.97-4.74 17.97-4.74s-22.9 2.74-26.21 3.42l-.4.11c0-.02.14-.06.4-.1 10.6-3.09 29.79-7.79 33.83-8.77l.76-.19c1.77-.4 3.82-.63 6.26-.84 8.74-.74 10.65 1.32 8.11 7.13l-2.19 5.01-8.98.77.88-2.02c1.61-3.69 1.43-3.95-1.12-3.73-2.67.23-3.3 1.28-4.16 3.24l-1.2 2.76c-1.16 2.65-.63 3.05 2.04 3.49 9.59 1.73 10.47 2.38 5.8 13.1C107.21 61.88 102.55 64 94 64.73c-10.92.93-11.87-1.32-8.25-9.62l1.51-3.45 9.34-.8zm8.8-27.71l.76-.19-.76.19z"
                                        fill="#fff"
                                    ></path>
                                    <path
                                        d="M276 21.66h.44c.51 0 .94-.19.94-.67 0-.33-.24-.67-.94-.67-.2 0-.34.01-.44.03v1.3zm0 2.14h-.62v-3.87c.32-.05.63-.09 1.1-.09.58 0 .96.12 1.2.3.22.16.35.42.35.8 0 .5-.34.81-.76.93v.03c.34.06.57.37.65.94.1.6.19.84.25.96h-.65c-.1-.12-.18-.48-.26-.99-.1-.49-.34-.67-.83-.67h-.44v1.66zm.64-4.94a2.86 2.86 0 00-2.77 2.92 2.86 2.86 0 002.79 2.94c1.54.02 2.77-1.3 2.77-2.92a2.85 2.85 0 00-2.77-2.94h-.02zm.02-.54c1.9 0 3.4 1.54 3.4 3.46 0 1.96-1.5 3.48-3.42 3.48a3.44 3.44 0 01-3.43-3.48 3.44 3.44 0 013.43-3.46h.02"
                                        fill="#00502F"
                                    ></path>
                                </svg>
                                <br />
                                <br />
                                {<>{IVRSettings.subtitle}</>}
                            </div>
                        </>
                    )}

                    {categories && categories.length > 0 ? (
                        <Grid container spacing={1} className="categoryContainer">
                            {!categoriesLoading ? (
                                <>
                                    {categories.map((category) => (
                                        <Grid item xs={12} key={category.slug}>
                                            {category.custom_route ? (
                                                <Link to={"/landing?c=" + category.slug + "&cid=" + clientUUID + "&route=" + category.custom_route} onClick={() => linkClicked(category.slug, clientUUID, category.auth_checkpoint, category.custom_route)} className="categoryButtonHolder">
                                                    <Button variant="outlined" className="categoryButton">
                                                        {category.label}
                                                    </Button>
                                                </Link>
                                            ) : (
                                                <Link to={"/landing?c=" + category.slug + "&cid=" + clientUUID} onClick={() => linkClicked(category.slug, clientUUID, category.auth_checkpoint)} className="categoryButtonHolder">
                                                    <Button variant="outlined" className="categoryButton">
                                                        {category.label}
                                                    </Button>
                                                </Link>
                                            )}
                                        </Grid>
                                    ))}
                                    {categorySlug === "root" ? (
                                        <>
                                            <Grid container>
                                                <Card sx={{ display: "flex", width: "100%", margin: "10px 1px 0px 7px" }}>
                                                    <Box sx={{ display: "flex", flexDirection: "column", width: "70%" }}>
                                                        <CardContent sx={{ flex: "1 0 auto" }}>
                                                            <Typography variant="subtitle1" color="text.secondary" component="div">
                                                                <b>Tiffany Sloane</b>
                                                                <br />
                                                                Customer Service
                                                                <br />
                                                            </Typography>
                                                        </CardContent>
                                                        <Box sx={{ display: "flex", alignItems: "center", pl: 1, pb: 1 }}>
                                                            {audioPlaying ? (
                                                                <IconButton aria-label="play/pause" onClick={() => pauseIntroAudio()}>
                                                                    <PauseOutlined sx={{ height: 30, width: 30 }} />
                                                                </IconButton>
                                                            ) : (
                                                                <IconButton aria-label="play/pause" onClick={() => playIntroAudio()}>
                                                                    <PlayArrowIcon sx={{ height: 30, width: 30 }} />
                                                                </IconButton>
                                                            )}

                                                            <Typography style={{ fontSize: "0.7em", marginLeft: "10px", textAlign: "left" }}>I can help you with this system. Press play for more info...</Typography>
                                                        </Box>
                                                    </Box>
                                                    <CardMedia component="img" sx={{ width: "30%", alignItems: "right" }} image="/assets/img/agent.png" alt="Live from space album cover" />
                                                </Card>
                                            </Grid>
                                            <audio src="assets/mp3/speedy_intro.mp3" ref={audioRef} />
                                        </>
                                    ) : (
                                        <></>
                                    )}
                                </>
                            ) : (
                                <></>
                            )}
                        </Grid>
                    ) : (
                        <>
                            {!categoriesLoading ? (
                                <>
                                    <Grid container spacing={0}>
                                        <Grid item xs={12}>
                                            <div className="contactForm">
                                                {(!verified && !customRoute) ?? (
                                                    <>
                                                        Please verify your account information before continuing.
                                                        <br />
                                                        <br />
                                                    </>
                                                )}
                                                <>
                                                    {!verified && !customRoute ? (
                                                        <>
                                                            <>
                                                                <form ref={customerForm}>
                                                                    <Grid container spacing={1} className="categoryContainer">
                                                                        <Grid item xs={12}>
                                                                            <div className="form-group">
                                                                                <label className="fieldLabel">ZIP Code</label>
                                                                                <input onChange={(e) => updateCustomerField("zip_code", e.target.value)} type="tel" value={customerFields.zip_code} className="form-control" pattern="/d*" maxLength={5} style={{ textAlign: "center" }} />
                                                                            </div>
                                                                            <div className="form-group">
                                                                                <label className="fieldLabel">Last 4 SSN</label>
                                                                                <input onChange={(e) => updateCustomerField("last_4_ssn", e.target.value)} value={customerFields.last_4_ssn} type="tel" className="form-control" pattern="/d*" maxLength={4} style={{ textAlign: "center" }} />
                                                                            </div>
                                                                            <div className="form-group">
                                                                                <label className="fieldLabel">Date of Birth</label>
                                                                                <Grid container spacing={1}>
                                                                                    <Grid item xs={6}>
                                                                                        {" "}
                                                                                        <select onChange={(e) => updateCustomerField("dob_month", e.target.value)} className="form-control" style={{ textAlign: "center" }} value={customerFields.dob_month}>
                                                                                            <option value="01">January</option>
                                                                                            <option value="02">February</option>
                                                                                            <option value="03">March</option>
                                                                                            <option value="04">April</option>
                                                                                            <option value="05">May</option>
                                                                                            <option value="06">June</option>
                                                                                            <option value="07">July</option>
                                                                                            <option value="08">August</option>
                                                                                            <option value="09">September</option>
                                                                                            <option value="10">October</option>
                                                                                            <option value="11">November</option>
                                                                                            <option value="12">December</option>
                                                                                        </select>
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                        <input onChange={(e) => updateCustomerField("dob_day", e.target.value)} value={customerFields.dob_day} type="tel" className="form-control" pattern="/d*" maxLength={2} placeholder="DD" style={{ textAlign: "center" }} />
                                                                                    </Grid>
                                                                                    <Grid item xs={3}>
                                                                                        <input onChange={(e) => updateCustomerField("dob_year", e.target.value)} value={customerFields.dob_year} type="tel" className="form-control" pattern="/d*" maxLength={4} placeholder="YYYY" style={{ textAlign: "center" }} />
                                                                                    </Grid>
                                                                                </Grid>
                                                                            </div>
                                                                            <Button onClick={(e) => processForm(e)} variant="outlined" className="continueButton btn-block" ref={loginButton}>
                                                                                Continue
                                                                            </Button>
                                                                            <br />
                                                                            <br />
                                                                            {errorMessage}
                                                                        </Grid>
                                                                    </Grid>
                                                                </form>
                                                            </>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {customRoute}{" "}
                                                            {customVar === "changeDueDate" ? (
                                                                <>
                                                                    <h4>Change Due Date</h4>
                                                                    <div className="headerRow">Please select a new due date below. You may adjust the date by up to {customerFields.max_date_change_days} days.</div>
                                                                    <br />
                                                                    <Divider />
                                                                    <br />
                                                                    <Grid item>Current Due Date</Grid>
                                                                    <Grid item justifyContent="flex-end">
                                                                        <b>{formatDate(customerFields.loan_due_date)}</b>
                                                                    </Grid>
                                                                    <br />
                                                                    <Divider />
                                                                    <br />
                                                                    <Grid item>New Due Date</Grid>
                                                                    <br />
                                                                    <Grid item justifyContent="flex-end">
                                                                        <FormControl fullWidth>
                                                                            {dateRange && dateRange.length > 0 ? (
                                                                                <Select labelId="demo-simple-select-label" id="demo-simple-select" value={newDueDate} onChange={handleChangeDueDate} size="small">
                                                                                    <MenuItem value="">
                                                                                        <em>Select Date...</em>
                                                                                    </MenuItem>
                                                                                    {dateRange.map((date, i) => (
                                                                                        <MenuItem key={date.date} value={i}>
                                                                                            {date.label}
                                                                                        </MenuItem>
                                                                                    ))}
                                                                                </Select>
                                                                            ) : (
                                                                                <></>
                                                                            )}
                                                                        </FormControl>
                                                                    </Grid>
                                                                    <br />
                                                                    <br />
                                                                    <Button variant="contained" disableElevation fullWidth onClick={(e) => updateDueDate(e)}>
                                                                        Confirm Changes
                                                                    </Button>
                                                                    <br />{" "}
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                            {customVar === "dueDateChanged" ? (
                                                                <>
                                                                    <h4>Due Date Changed</h4>
                                                                    <div className="headerRow">Your due date was updated</div>
                                                                    <br />
                                                                    <Divider />
                                                                    <br />
                                                                    <Grid item>Previous Due Date</Grid>
                                                                    <Grid item justifyContent="flex-end">
                                                                        <b>{formatDate(customerFields.loan_due_date)}</b>
                                                                    </Grid>
                                                                    <br />
                                                                    <Divider />
                                                                    <br />
                                                                    <Grid item>Updated Due Date</Grid>
                                                                    <Grid item justifyContent="flex-end">
                                                                        <b>{formatDate(newDueDate)}</b>
                                                                    </Grid>
                                                                    <br />
                                                                    <br />
                                                                </>
                                                            ) : (
                                                                <></>
                                                            )}
                                                        </>
                                                    )}
                                                </>
                                            </div>
                                        </Grid>
                                    </Grid>
                                </>
                            ) : (
                                <div></div>
                            )}
                        </>
                    )}
                </Grid>
                <Grid item xs={3}>
                    &nbsp;
                </Grid>
            </Grid>
        </>
    );
}
